import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { prepareColor } from "../../../../internal/utils/prepareColor.js";
import { BackgroundQualifier } from "./BackgroundQualifier.js";
/**
 * @description Defines the background color to use when resizing with padding.
 * @memberOf Qualifiers.Background
 * @extends {Qualifiers.Background.BackgroundQualifier}
 */

var BaseCommonBackground = /*#__PURE__*/function (_BackgroundQualifier) {
  _inherits(BaseCommonBackground, _BackgroundQualifier);

  var _super = _createSuper(BaseCommonBackground);

  function BaseCommonBackground() {
    var _this;

    _classCallCheck(this, BaseCommonBackground);

    _this = _super.call(this);
    _this._palette = [];
    return _this;
  }
  /**
   * @description Selects the strongest contrasting color to use for padding.
   * @return {this}
   */


  _createClass(BaseCommonBackground, [{
    key: "contrast",
    value: function contrast() {
      this._contrast = true;
      return this;
    }
    /**
     * @description Defines the custom colors to use when resizing using content-aware padding.
     * @param {...string} colors One or more colors - Example: palette('green', 'red', blue')
     * @return {this}
     */

  }, {
    key: "palette",
    value: function palette() {
      for (var _len = arguments.length, colors = new Array(_len), _key = 0; _key < _len; _key++) {
        colors[_key] = arguments[_key];
      }

      this._palette = colors.map(function (color) {
        return prepareColor(color);
      });
      return this;
    }
  }]);

  return BaseCommonBackground;
}(BackgroundQualifier);

export { BaseCommonBackground };